import { render, staticRenderFns } from "./TaskDetails.vue?vue&type=template&id=b66d92c6&scoped=true&"
import script from "./TaskDetails.vue?vue&type=script&lang=ts&"
export * from "./TaskDetails.vue?vue&type=script&lang=ts&"
import style0 from "./TaskDetails.vue?vue&type=style&index=0&id=b66d92c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66d92c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VRow,VSpacer,VTextField})
